export class Aviso {
  ideAditivo: number;
  ideAviso: number;
  ideTipoAviso: number;
  nomeTipoAviso: string;
  mensagem: string;
  usuario: string;
  data: Date;
  descricaoAviso: string
}
